export const validateWebsiteUrl = (url) => {
    try {
        return websitePattern.test(url);
    } catch (err) {
        return false;
    }
};

export const websitePattern =
    /\b(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/\S*)?\b/;
